import { Store } from "redux";
import { observeStore } from "./utils";

export class Discount<T extends { amount: number }> {
  element: HTMLElement;
  store: Store;
  stateSelector: (store: Store) => T;

  constructor(selector: string, store: Store, stateSelector: (store: Store) => T) {
    this.element = document.querySelector(selector);

    if (!this.element) return;

    this.store = store;
    this.stateSelector = stateSelector;
    this.bindEvents();
  }

  bindEvents() {
    observeStore(this.store, this.stateSelector, this.handleStoreChange);
  }

  handleStoreChange = (state: T) => {
    if (!state) {
      this.element.innerHTML = "0.00";
    } else {
      if (Array.isArray(state)) {
        this.element.innerHTML = String(state.reduce((acc, voucher) => acc + voucher.amount, 0).toFixed(2));
      } else {
        this.element.innerHTML = String(state.amount.toFixed(2));
      }
    }
  };
}
